import { Link } from "react-router-dom";

export default function ComingSoonPage({ name }) {
  return (
    <div className="min-h-screen flex items-center justify-center" data-testid={`coming-soon-${name}`}>
      <div className="text-center px-6">
        <h1 className="font-display font-bold text-3xl text-white mb-4">{name}</h1>
        <p className="text-geminii-muted mb-8">Coming soon.</p>
        <Link to="/space" className="text-rogue-cyan text-sm hover:underline">
          Back to Geminii Space
        </Link>
      </div>
    </div>
  );
}
